import { useTranslation } from "react-i18next";

export default function Socials(){
    const { t } = useTranslation();
    const socials = [
    
    {
        icon:"facebook.svg",
        name:"LM PLATINUM ESTATES",
        description:"Avec LM Platinum Estates, investissez en toute confiance dans des biens titrés, vérifiés et accessibles en un clic😁😁",
        image:"5379637510122105174.jpg",
        link:"https://www.facebook.com/lmplatinumestates/",
        maxheight:"230px",
        width:"360px"
    },
    {
        icon:"tiktok.svg",
        name:"LM PLATINUM ESTATES",
        description:"Avec LM Platinum Estates, investissez clic😁😁",
        image:"terrain_default.jpg",
        link:"https://www.tiktok.com/@lmplatinumestates?lang=fr",
        maxheight:"230px",
        width:"320px"
    },
    {
        icon:"instagram.svg",
        name:"LM PLATINUM ESTATES",
        description:"Avec LM Platinum Estates, investissez clic😁😁",
        image:"5379637510122105179.jpg",
        link:"https://www.instagram.com/lm.platinumestates237",
        maxheight:"230px",
        width:"450px"
    },
]

    return(
        <>
            <div className="main-content-block blue-rounded-border">
                <div id='socials-block'>
                    <br/>
                    <br/>
                    <div id = 'title'>{t('Rejoignez-nous sur les réseaux sociaux !')}</div>
                    <br/>
                    <div id = 'description'>{t('Consultez nos offres pour les mises à jour et posez des questions')}</div>
                    <br/>
                    <br/>
                    <div id='cards'>
                        {socials.map(x=>
                            <a href={x.link} target="_blank">
                                <div>
                                    <div id='icon'><img src={x.icon}/></div>
                                    <div id='name'>{x.name}</div>
                                    <br/>
                                    <div id='description'>{x.description}</div>
                                    <br/>
                                    <div id='image' style={{"maxHeight":x.maxheight}}><img style={{"width":x.width}} src={x.image}/></div>
                                </div>
                            </a>
                        )}
                    </div>
                </div>
            </div>
        </>
    )
}